'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

import VaultListingLayout from '../VaultListingLayout'

const VaultListingError = () => {
  return (
    <VaultListingLayout>
      <ErrorDataUnavailable minHeight="320px" />
    </VaultListingLayout>
  )
}

export default memo(VaultListingError)
